import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { downloadSalesCsv }  from "./exportCsv"

export const SalesFilters = ({
  types,
  years,
  previous,
  filters,
  setFilters,
  fiscalYearStartMonth,
  data,
  months,
  currency,
  encodingName,
  partnerFilter
}) => {
  const [year, setYear] = useState(filters.year)

  const handleChange = (type, value) => {
    setFilters({ ...filters, [type]: value })
  }

  const changeYear = newYear => {
    setYear(newYear)
    handleChange('year', newYear)
  }

  const getFiscalYearLabel = year => {
    if (fiscalYearStartMonth === 1) {
      return year.toString()
    }

    const monthNames     = I18n.t("date.abbr_month_names").slice(1)
    const startMonthName = monthNames[fiscalYearStartMonth - 1]
    const endMonthName   = monthNames[fiscalYearStartMonth - 2]

    return `${startMonthName} ${year} - ${endMonthName} ${year + 1}`
  }

  const canExport = data && data.props_month_type && Object.keys(data.props_month_type.members || {}).length > 0

  const handleExport = () => {
    const typeEntry  = types.find(t => t[1] == filters.type)
    const typeLabel  = typeEntry ? typeEntry[0] : ""
    const titleSlug  = (I18n.t("invoices.sales_statistics.title") || "turnover")
                        .toString()
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, "_")
                        .replace(/^_|_$/g, "")
    const filename   = `${titleSlug}_${filters.year}.csv`

    downloadSalesCsv({ data, months, currency, typeLabel, filename, encodingName })
  }

  if (!types || !years) return <div className = "dot-elastic"></div>

  return (
    <div id="product-container">
      <div className = "dashboard__card dashboard__filters j-c-between">
        <div className = "d-flex j-c-between a-i-center w-100">
          <div className = "dashboard__year__selectors w-40">
            <div className = "d-flex a-i-center">
              {
                year > years[0] &&
                <span onClick={() => changeYear(year - 1)}>
                  <FontAwesomeIcon icon="arrow-left" />
                </span>
              }
              <h2>{getFiscalYearLabel(year)}</h2>
              {
                year < years[years.length - 1] &&
                <span onClick={() => changeYear(year + 1)}>
                  <FontAwesomeIcon icon="arrow-right" />
                </span>
              }
            </div>    
          </div>

          <div className = "d-flex j-c-end w-100">
            { partnerFilter &&
              <select
                className = "form-control w-fit mr-2"
                name      = "partner"
                title     = { partnerFilter.label }
                value     = { filters.partner || "" }
                onChange  = { e => { handleChange('partner', e.target.value) } }
              >
                { partnerFilter.all && <option value="">{ partnerFilter.allLabel }</option> }
                { partnerFilter.options.map(entity => (
                  <option value = { entity.id } key = { entity.id }>{ entity.name }</option>
                ))}
              </select>
            }

            <select
              className = "form-control w-fit mr-2"
              name      = "previous"
              value     = { filters.previous }
              onChange  = { e => { handleChange('previous', e.target.value) } }
            >
              { previous.map(month => {
                return (
                  <option 
                    value = { month }
                    key   = { month }
                  >
                    { I18n.t(`invoices.sales_statistics.comparison_years_${month}`) }
                  </option>
                )
              })}
            </select>

            <select
              className = "form-control w-fit mr-2"
              name      = "type"
              value     = { filters.type }
              onChange  = { e => { handleChange('type', e.target.value) } }
            >
              { types.map(type => {
                return (
                  <option
                    value = { type[1] }
                    key   = { type[1] }
                  >
                    { type[0] }
                  </option>
                )
              })}
            </select>

            <button
              type      = "button"
              className = "btn btn-primary"
              onClick   = { handleExport }
              disabled  = { !canExport }
              title     = { I18n.t("invoices.sales_statistics.csv_export") }
            >
              <FontAwesomeIcon icon="file-csv" />
              <span className="ml-2">{ I18n.t("invoices.sales_statistics.csv_export") }</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}